module.exports = __webpack_public_path__ + "img/cloud-bolt-moon.e0e9cc3c.svg";